/**
 * VRG-677 — may this reader send a question to Ask Vera right now, and if not, why.
 *
 * Decided BEFORE sending, from the same effective permission set the server's guard
 * uses: `useCanAccess` already reads the space grant inside a space and the user's own
 * role outside one. So the panel can disable its input and say whose permission is
 * missing instead of letting the question go out and come back as a bare 403.
 */
import { useCanAccess } from 'hooks/useCanAccess'
import { useVeraSpaceStore } from 'stores'
import { permissionLabel } from 'utils/permissionLabels'
import { ASK_PERMISSION, resolveAskAccess } from 'utils/veraSupportAccess'

export const useAskAccess = () => {
  const inSpace = !!useVeraSpaceStore(s => s.companyId)
  const { isHasAccess } = useCanAccess({ action: ASK_PERMISSION })
  return resolveAskAccess({
    inSpace,
    canUseAi: isHasAccess,
    permissionLabel: permissionLabel(ASK_PERMISSION),
  })
}
